import { Injectable } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

@Injectable()
export class InAppBrowserUtils {
  constructor() {}

  openUrl(url: string): void {
    if (Capacitor.isNativePlatform()) {
      Browser.open({ url });
    } else {
      this.openUrlOnWeb(url);
    }
  }

  /**
   * Closes the in-app browser if it is currently open (native only).
   * Use this to return the user to the app after an external flow
   * (e.g. identity verification) completes, instead of leaving the
   * external/redirect web page visible.
   */
  async closeUrl(): Promise<void> {
    if (Capacitor.isNativePlatform()) {
      try {
        await Browser.close();
      } catch {
        // Browser may already be closed; ignore.
      }
    }
  }

  private openUrlOnWeb(url: string): void {
    // Check if running on iOS Safari
    const isIOSSafari =
      /iPad|iPhone|iPod/.test(navigator.userAgent) &&
      /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (isIOSSafari) {
      // For iOS Safari, use location.href instead of window.open to avoid popup blocker
      window.location.href = url;
    } else {
      window.open(url, '_blank');
    }
  }
}
